import { render } from "./Mint.vue?vue&type=template&id=06b25b2b&scoped=true&ts=true"
import script from "./Mint.vue?vue&type=script&lang=ts"
export * from "./Mint.vue?vue&type=script&lang=ts"

import "./Mint.vue?vue&type=style&index=0&id=06b25b2b&lang=scss&scoped=true"

import exportComponent from "C:\\bonch\\okimi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b25b2b"]])

export default __exports__